var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.tooltip),expression:"tooltip",modifiers:{"bottom":true}}],staticClass:"circle",class:_vm.iconClass,style:({backgroundColor: _vm.backgroundColor, color: _vm.color}),attrs:{"type":"button"},on:{"click":function($event){return _vm.submit()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }